import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '@/api/client';
import Logo from '@/components/Logo';
import { ShieldCheck, LogIn, Users } from 'lucide-react';
import { toast } from 'sonner';

const DEPTS = ['Media','Worship','Sunday School','VBS','Evangelism','House Keeping','Catering'];

export default function TeamsLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ department: 'Media', username: '', password: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('moj_team_token')) nav('/teams/dashboard');
  }, [nav]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/teams/login', form);
      localStorage.setItem('moj_team_token', data.token);
      localStorage.setItem('moj_team_leader', JSON.stringify(data.leader));
      toast.success(`Welcome, ${data.leader.full_name}`);
      nav('/teams/dashboard');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-moj-cream flex items-center justify-center px-4 py-16">
      <div className="card-moj p-8 max-w-md w-full">
        <div className="flex justify-center mb-4"><Logo size="lg" showText={false}/></div>
        <h1 className="font-serif text-2xl text-center text-moj-purple-deep mb-1 flex items-center justify-center gap-2"><Users/> Team Portal</h1>
        <p className="text-center text-sm text-moj-charcoal/70 mb-6">For team leaders. Approved members of the team will appear here after admin approval.</p>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="team-login-form">
          <div><label className="label-moj">Team</label>
            <select className="input-moj" value={form.department} onChange={(e) => setForm({...form, department: e.target.value})} data-testid="team-login-dept">
              {DEPTS.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div><label className="label-moj">Username</label><input className="input-moj" required value={form.username} onChange={(e) => setForm({...form, username: e.target.value})}/></div>
          <div><label className="label-moj">Password</label><input className="input-moj" type="password" required value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}/></div>
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="team-login-submit"><LogIn size={16}/> {loading ? 'Signing in…' : 'Sign in'}</button>
        </form>
        <p className="text-xs text-center text-moj-charcoal/60 mt-4 flex items-center justify-center gap-1"><ShieldCheck size={12}/> Encrypted login • Audit logged</p>
        <p className="text-xs text-center text-moj-charcoal/60 mt-2">Forgot password? Ask the pastor to reset it via <Link to="/pastor" className="text-moj-purple underline">pastor portal</Link>.</p>
      </div>
    </div>
  );
}
